'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mockI18N;

var _core = require('@lingui/core/cjs/core.development');

var _generateCatalogs = require('./generate-catalogs');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function mockI18N(window, locale, json) {
    var catalogs = _defineProperty({}, locale, (0, _generateCatalogs.compile)(locale, json));

    // NOTE: We pass locale as both "locale" and "language", because the name for
    //       that property was changed between version 2.9.x and 3.0.x of Lingui.
    //
    //       Providing both names avoids us having to come back and rework this
    //       code if we ever decide to move to Lingui 3.

    var i18n = (0, _core.setupI18n)({
        locale: locale,
        language: locale,
        catalogs: catalogs
    });

    window.localisation = { i18n: i18n };
}


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/lingui-cdn/lib/i18n/i18n-mocker.js
// module id = T/Tj
// module chunks = 0